import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Globals } from './globals';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class RestApiService {
  // Define API
  queryParam: string = ''; // = '?period=2018-2020';
  //curriculumPeriod = environment.curriculumPeriod;
  apiURL = 'http://localhost:3000';

  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private http: HttpClient
  ) {
    this.globals.schoolYearChanged.subscribe(year => this.onPeriodChange(year)); 
    this.route.queryParams.subscribe(params => {
      params['period'] !== undefined ? this.queryParam = 'period=' + params['period'] : this.queryParam = '';
    });

  }


  /*========================================
    CRUD Methods for consuming RESTful API
  =========================================*/
  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  // HttpClient API get() method => Fetch list
  getList(endpoint: string): Observable<any> {
    return this.http
      .get<any>(this.buildUrl(endpoint))
      .pipe(retry(0), catchError(this.handleError));
  }

  getSubList(endpoint: string, id: string): Observable<any> {
    return this.http
      .get<any>(this.buildUrlWithId(endpoint, id))
      .pipe(retry(0), catchError(this.handleError));
  }

  // HttpClient API get() method => Fetch employee
  getOne(endpoint: string, id: string): Observable<any> {
    return this.http
      .get<any>(this.buildUrlWithId(endpoint, id))
      .pipe(retry(0), catchError(this.handleError));
  }

  getFilteredList<T>(endpoint: string, filter: string): any {
    return this.http.get(this.buildUrlWithFilter(endpoint, filter))

  }
  /*getOne<T>(endpoint: string, id: string): any {
    
    return this.http.get(this.buildUrlWithId(endpoint, id))
  }*/

  search<T>(endpoint: string): any {
    return this.http.get(this.buildUrl(endpoint))
     /* .map(this.extractData)
      .catch(this.handleError)*/;
  }

  private buildUrl(endpoint: string): string {
    return `${environment.backendUrl}/api/${endpoint}${'?' + this.queryParam}`;
  }

  private buildUrlWithId(endpoint: string, id: string): string {
    return `${environment.backendUrl}/api/${endpoint}/${id}${'?' + this.queryParam}`;
  }

  private buildUrlWithFilter(endpoint: string, filter: string): string {
    return `${environment.backendUrl}/api/${endpoint}${'?' + filter + '+' + this.queryParam}`;
  }

  
  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }

  private onPeriodChange(year: number): void {
    this.queryParam = 'period=' + this.globals.selectedCurriculumPeriod;
    //this.globals.selectedSchoolYear.toString() + '-' + (this.globals.selectedSchoolYear+this.curriculumPeriod).toString();
    //console.log('kutsun periodi: ' + this.queryParam);
   }

}
